<tt-page *ngIf="!!setting">
    <tt-page-heading ttModel="p2_m_activitygrid" ttTranslate></tt-page-heading>

    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-4 p-5">
            <tt-select ttRememberId="w_activitygrid.businessco_no" ttLabel="businessco" [(ttModel)]="setting.businessco_no" (ttModelChange)="onChanged($event, 'businessco_no')" [ttData]="selectListCompanies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
            <tt-search ttLabel="cust_name" [(ttModel)]="setting.cust_name" [ttSearch]="searchCustomerNames" (ttOnSelected)="onCustomerNameSelected($event)" (ttOnClear)="onCustomerNameSelected()"></tt-search>
            <tt-select ttRememberId="w_activitygrid.ok" ttLabel="ok" [(ttModel)]="setting.ok" (ttModelChange)="onChanged($event, 'ok')" [ttData]="selectListOks" ttDataId="ok" ttDataName="ok_name"></tt-select>
        </tt-card>

        <tt-card class="col-xs-12 col-md-4 p-5">
            <tt-button-goto *ngIf="setting.cust_no === '0'" [ttText]="'activitygrid_new_tast'" (ttClick)="goToFunc('custactedit1')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
            <tt-button-goto *ngIf="setting.cust_no !== '0'" [ttText]="'activitygrid_new_tast'" (ttClick)="goToFunc('custactedit2')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
        </tt-card>
    </div>

    <tt-grid *ngIf="!!grid" class="p-5 flex-1" [(ttOptions)]="grid"></tt-grid>
</tt-page>
